import React, { useState } from 'react';
import logo from '../logo_bellascelta.png';
import CountrySelector from './CountrySelector';

const Header = ({ user, isPWA, notificationsEnabled, lastUpdate, onRefresh, onLogout, country, onCountryChange, countries }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [spinning, setSpinning] = useState(false);

  const initials = user?.name
    ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  const handleRefresh = () => {
    setSpinning(true);
    onRefresh();
    setTimeout(() => setSpinning(false), 600);
  };

  return (
    <header>
      <div className="header-content">
        <div className="header-left">
          <img src={logo} alt="Bellascelta" className="header-logo" />
        </div>
        <div className="header-center">
          <CountrySelector
            country={country}
            onCountryChange={onCountryChange}
            countries={countries}
          />
        </div>
        <div className="header-right">
          <button
            className={`header-icon-btn ${spinning ? 'refresh-spinning' : ''}`}
            onClick={handleRefresh}
            aria-label="Aggiorna dati"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
            </svg>
          </button>
          <div style={{ position: 'relative' }}>
            <div
              className="header-avatar"
              onClick={() => setShowMenu(!showMenu)}
              role="button"
              tabIndex={0}
              aria-label="Menu profilo"
              onKeyDown={(e) => e.key === 'Enter' && setShowMenu(!showMenu)}
            >
              {initials}
            </div>
            {showMenu && (
              <>
                <div className="profile-menu-overlay" onClick={() => setShowMenu(false)} />
                <div className="profile-menu">
                  <div className="profile-menu-header">
                    <div className="profile-menu-name">{user?.name}</div>
                    <div className="profile-menu-email">{user?.email}</div>
                  </div>
                  <button className="profile-menu-item" disabled>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                    {isPWA ? 'PWA' : 'Browser'} {notificationsEnabled ? '· Notifiche attive' : ''}
                  </button>
                  <button className="profile-menu-item" disabled>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>
                    {lastUpdate.toLocaleTimeString('it-IT')}
                  </button>
                  <button className="profile-menu-item danger" onClick={() => { setShowMenu(false); onLogout(); }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                      <polyline points="16 17 21 12 16 7"/>
                      <line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                    Esci
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
